import React, { memo, useEffect, useState } from 'react';
import './css/style.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';
SwiperCore.use([EffectFade, Autoplay]);
import { toast } from 'react-toastify';

import Form from 'react-bootstrap/Form';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { log } from '../../../../common/common';

import appConfig from '../../../../config/config';

import { Fade } from 'react-reveal';
import ShareCard from '../../../ShareCard';
import { CLICK_SUBMIT_POLL } from '../../../../TrackerFolder/constants/ActionType';
import { onSubmitPoll } from '../../../../TrackerFolder/actions/dashboardActions';
import axiosInstance from '../../../../Store/helper/axiosInstance';
import { useTracker } from '../../../../TrackerFolder/TrackerComponent';
import LazyImage from '../../../CustomLibraries/LazyImage';
// install Swiper modules
// let qArray = [];
const url = appConfig.apiLoc;
const MultiplePollCard = ({ data, gtmTagVariable = '' }) => {
  let sponsorLogo = data?.sponsor_logo ? data?.sponsor_logo.split(',') : [];
  const [currOptions, setCurrOptions] = useState({});
  const [questionNo, setQuestionNo] = useState(0);
  const [render, setRender] = useState(false);
  const [ansGiven, setAnsGiven] = useState(false);
  const { trackActivityEvent } = useTracker();
  const [qArray, setQarray] = useState([]);
  const refresh = () => setRender(!render);
  useEffect(() => {

    if (data?.json_data) {
      var parsedData = JSON.parse(unescape(data.json_data));
      let qArrayTemp = Object.keys(parsedData?.surveys).map((k) => {
        return parsedData.surveys[k];
      });
      var { question0, options0 } = qArrayTemp[0];
      setQarray(qArrayTemp);
      setCurrOptions(options0);
    }
  }, []);
  const onPollSubmit = () => {
    typeof trackActivityEvent == 'function' &&
      trackActivityEvent(CLICK_SUBMIT_POLL, onSubmitPoll(data.survey_id, ''));

    axiosInstance
      .post('survey/pollAnswer', {
        answer_json: JSON.stringify(qArray),
        survey_id: data.survey_id
      })
      .then((res) => {
        axiosInstance
          .get(`survey/pollResult?id=${data.survey_id}`)
          .then((response) => {
            log('Poll result', JSON.parse(response.data.data)[0]);
            setCurrOptions(JSON.parse(response.data.data)[0]);
            setAnsGiven(true);
            setQuestionNo(0);
            axiosInstance
              .post('survey/addpoint', {
                point: data.point,
                survey_id: data.survey_id
              })
              .then((resp) => {
                toast.success(`You have got ${data.point} points`);
              })
              .catch((e) => {
                log('Error', e);
              });
          })
          .catch((e) => {
            log('Error', e);
          });
      })
      .catch((e) => {
        log('Error', e);
      });
  };

  const handleRadioChange = (index, value) => {
    qArray[questionNo].selectedIndex = index;
    //setQuestionNo(questionNo + 1);
    setQarray(qArray);
    log('modified', qArray);
    if (questionNo < qArray.length - 1) {
      setQuestionNo(questionNo + 1);
    } else if (questionNo == qArray.length - 1) {
      onPollSubmit();
    }
  };
  return (
    <>
      <div className="w-100 pollCardV1Box shadow rounded-3 bg-white position-relative overflow-hidden p-3 p-md-4">
        <span
          className="graph-1 position-absolute start-0 bottom-0"
          style={{ backgroundColor: '#28ca5a' }}
        ></span>
        <span
          className="graph-2 position-absolute start-0 bottom-0"
          style={{ backgroundColor: '#28ca5a' }}
        ></span>

        <div className="w-100 float-start pollCrdV1Btm">
          <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative mb-2">
            {/* <span className="crdV1topPartGraph" style={{ backgroundColor: "#28ca5a" }}></span> */}
            <h4 className="text-black rounded fs-4 pollCardV1Point py-2 px-3 border border-dark">
              <span className="fw-bold">{data?.point}</span> Points
            </h4>
            <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
              <ShareCard
                data={{ title: data?.survey_title, url: data?.deeplink }}
                customClass={`gtm_cl_mutiplePollCard_share`}
                // id={`${gtmTagVariable}_mutiplePollCard_card_share_${data.id}`}
              />
            </a>
          </div>
          <div className="w-100 float-start d-flex text-start cardV1Topic mb-2">
            <div className="cardV1TopicContent position-relative w-100">
              <h4 className="text-black fs-16 fw-medium">{qArray[questionNo]?.question}</h4>
            </div>
          </div>
          <div className="w-100 float-start cardV1Ftr mt-2">
            {!ansGiven ? (
              <Form>
                {qArray[questionNo]?.options &&
                  qArray[questionNo]?.options.map((_opt, _idx) => (
                    <Form.Check
                      key={_idx + 1}
                      className={`pollCardV1Radio fs-4 p-0 mb-3 position-relative cursorPointer gtm_cl_mutiplePollCard_options`}
                      label={_opt.label}
                      name={`${questionNo}group${data.survey_id}`}
                      checked={qArray[questionNo].selectedIndex === _opt.value}
                      type="radio"
                      id={'poll' + data.survey_id + _opt.value + questionNo}
                      onChange={() => {
                        handleRadioChange(_opt.value, _opt.label);
                      }}
                    // onChange={() => {
                    //     onPollSubmit(_opt.value, data.survey_id);
                    // }}
                    />
                  ))}
              </Form>
            ) : null}
            {ansGiven ? (
              <Fade bottom>
                <div className="w-100 float-start pollCardV1Ansr">
                  {currOptions.options.map((_option, index) => (
                    <div className="fs_4 pollCardV1AnsrRow position-relative mb-3" key={index + 1}>
                      <ProgressBar now={_option.vote} />
                      <div
                        className={`pollCardV1AnsrRowIn py-4 position-relative z-2 text-start font-semibold ${currOptions.selectedIndex == _option.value ? 'text-primary' : 'text-black'
                          } `}
                      >
                        {_option.label}
                        <span className="position-absolute">{_option.vote}%</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Fade>
            ) : null}

            <h2 className="w-100 float-start text-black fw-medium fs-5 mt-2">
              {questionNo + 1 + ' / ' + qArray?.length}
            </h2>

            {/* sponser logo if single */}
            {sponsorLogo.length == 1 && (
              <div className="crdV1sponser mt-4 text-end float-end">
                <div className="crdV1sponserIn bg-white d-inline-flex justify-content-end align-items-center">
                  <LazyImage src={sponsorLogo[0]} className="float-end" alt="sponsor_logo" logo />
                </div>
              </div>
            )}
            {/* sponser logo if multiple */}
            {sponsorLogo.length > 1 && (
              <Swiper
                className="crdV1sponser mt-4 text-end float-end"
                navigation={false}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                autoplay={{
                  delay: 2500
                }}
                effect={'fade'}
              >
                {sponsorLogo.map((logo, _i) => (
                  <SwiperSlide
                    className="crdV1sponserIn bg-white d-inline-flex justify-content-end align-items-center"
                    key={_i + 1}
                  >
                    <LazyImage src={logo} className="float-end" alt="sponsor_logo" logo />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            {/* sponser logo if multiple */}
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(MultiplePollCard);
